<template>
  <div>
    <v-icon>add_location</v-icon>
      <vue-google-autocomplete
          v-if="id"
          ref="autocomplete"
          :id="id"
          class="headline"
          placeholder="Search address..."
          outlined
          v-on:placechanged="getAddressData"
          :country="country"
      >
      </vue-google-autocomplete>
    <vue-google-autocomplete
        v-else
        ref="autocomplete"
        id="map"
        class="headline"
        placeholder="Search address..."
        outlined
        v-on:placechanged="getAddressData"
        :country="country"
    >
    </vue-google-autocomplete>
  </div>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { VueGoogleAutocomplete },
  props: ['id', 'country'],
  data: function () {
    return {
      address: "",
    };
  },

  // mounted() {
  //   // To demonstrate functionality of exposed component functions
  //   // Here we make focus on the user input
  //   this.$refs.address.focus();
  // },

  methods: {
    getAddressData (addressData, placeResultData) {
      let local = {}
      local.formatted_address = placeResultData.formatted_address
      local.name = placeResultData.name
      local.url = placeResultData.url
      local.created = Date.now()
      this.address = addressData;
      this.$emit('locationFound', local)
      this.$refs.autocomplete.$refs.autocomplete.value = ''
    },
  },
};
</script>
